import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { Link } from 'react-router-dom';
import { injectIntl, defineMessages } from 'react-intl';
import classNames from 'classnames';

import CustomDate from '../../misc/CustomDate';
import { FormattedMessageWrappedInSpan } from '../../misc';

const EventListItem = props => {
  const {
    bannerHasGrayScale,
    event,
    hasFooter,
    hasPhotoCount,
    info,
    intl,
    linkTo,
    onClick,
    photoCount,
  } = props;

  function _renderInnerCard() {
    return (
      <div
        className="event-list-item-container-inner"
        onClick={() => onClick && onClick(event.sgId)}
      >
        <div
          className={classNames('event-list-item-banner', {
            'banner-gray-scale': bannerHasGrayScale,
          })}
        >
          <img src={event.banner} alt="" />
        </div>
        <div className="event-list-item-body">
          <div className="event-list-item-date">
            <CustomDate value={event.beginsAt} />
          </div>
          <h3 className="event-list-item-name">{event.name}</h3>
          {info}
        </div>
        {hasFooter && (
          <div className={classNames('event-list-item-footer', 'event-list-item-footer-action')}>
            {!hasPhotoCount && 
              <button className="redirect" onClick={() => onClick && onClick(event.sgId)}>
                <FormattedMessageWrappedInSpan
                  id="eventListItem.showAll"
                  defaultMessage="Show Photos"
                />
              </button>
            }
            {hasPhotoCount && 
              <div className={'event-list-item-action'}>
                <FormattedMessageWrappedInSpan
                  id="eventListItem.showAll"
                  defaultMessage="Show Photos"
                />
              </div>
            }
            {hasPhotoCount && <span className="event-list-item-count">{photoCount}</span>}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="event-list-item-container col-xs-8 col-sm-4">
      {linkTo ? (
        <Link to={linkTo}>{_renderInnerCard()}</Link>
      ) : (
        _renderInnerCard()
      )}
    </div>
  );
};

EventListItem.defaultProps = {
  bannerHasGrayScale: false,
  hasFooter: true,
  hasPhotoCount: false,
  info: null,
  linkTo: null,
  photoCount: null,
};

EventListItem.propTypes = {
  bannerHasGrayScale: PropTypes.bool,
  event: PropTypes.object,
  hasFooter: PropTypes.bool,
  hasPhotoCount: PropTypes.bool,
  info: PropTypes.node,
  intl: PropTypes.object,
  linkTo: PropTypes.string,
  onClick: PropTypes.func,
  photoCount: PropTypes.number,
};

export { EventListItem };

export default createFragmentContainer(injectIntl(EventListItem), {
  event: graphql`
    fragment EventListItem_event on Event {
      id
      sgId
      banner
      beginsAt
      name
    }
  `,
});
